jQuery(document).ready(function() {
    jQuery('.fp-tab-container .tab-link ').on('click', function (e) {
        jQuery(e.target).parents('.tab-container').find('.tab-link').removeClass('active');
        jQuery(this).addClass('active');
        let idx = jQuery(this).index();
        jQuery('.fp-tab-container .tab-content').removeClass('active').eq(idx).addClass('active');

    });
});


